import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_PRE_REGISTRATION_REJECTIONS, 
    ADD_NEW_PRE_REGISTRATION_REJECTION, 
    UPDATE_PRE_REGISTRATION_REJECTION, 
    DELETE_PRE_REGISTRATION_REJECTION 
} from "./actionTypes";

import {
    getPreRegistrationRejectionsSuccess,
    getPreRegistrationRejectionsFail,
    addNewPreRegistrationRejectionSuccess,
    addNewPreRegistrationRejectionFail,
    updatePreRegistrationRejectionSuccess,
    updatePreRegistrationRejectionFail,
    deletePreRegistrationRejectionSuccess,
    deletePreRegistrationRejectionFail,
   
} from "./actions"

import {
    getPreRegistrationRejections,
    addNewPreRegistrationRejection,
    updatePreRegistrationRejection,
    deletePreRegistrationRejection,
   
} from "helpers/pre-registration-rejections/pre_registration_rejections_backend_helper";
import { toast } from "react-toastify";

function* fetchPreRegistrationRejections() {
    try {
        const response = yield call(getPreRegistrationRejections)
        yield put(getPreRegistrationRejectionsSuccess(response))
    } catch (error) {
        yield put(getPreRegistrationRejectionsFail(error))
    }
}

function* onAddNewPreRegistrationRejection({ payload }) {
    try {

        console.log("PAYLOAD ON SAGA:", payload);
        const response = yield call(addNewPreRegistrationRejection, payload)

        console.log("RESPONSE:", response);
        yield put(addNewPreRegistrationRejectionSuccess(response.preRegistrationRejection))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addNewPreRegistrationRejectionFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdatePreRegistrationRejection({ payload: data }) {
    try {
        const response = yield call(updatePreRegistrationRejection, data)
        yield put(updatePreRegistrationRejectionSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updatePreRegistrationRejectionFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdatePreRegistrationRejection({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updatePreRegistrationRejection, payload)
        yield put(updatePreRegistrationRejectionSuccess(response.prestation))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updatePreRegistrationRejectionFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeletePreRegistrationRejection({ payload: data }) {

    try {
        const response = yield call(deletePreRegistrationRejection, data)
        yield put(deletePreRegistrationRejectionSuccess(response.prestationId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deletePreRegistrationRejectionFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* preRegistrationRejectionSaga() {
    yield takeEvery(GET_PRE_REGISTRATION_REJECTIONS, fetchPreRegistrationRejections)
    yield takeEvery(ADD_NEW_PRE_REGISTRATION_REJECTION, onAddNewPreRegistrationRejection)
    yield takeEvery(UPDATE_PRE_REGISTRATION_REJECTION, onUpdatePreRegistrationRejection)
    yield takeEvery(DELETE_PRE_REGISTRATION_REJECTION, onDeletePreRegistrationRejection)
}

export default preRegistrationRejectionSaga;